import Vue from "vue";
import { ServiceInterface } from "@/api/Interfaces/ServiceInterface";

const ServiceAppointProps = Vue.extend({
  props: {
    service: Object as () => ServiceInterface,

    opened: {
      type: Boolean,
      default: false,
    },
    cx_address: {
      type: String,
      default: null,
    },
    clinicAvailableHours: {
      default: null,
    },
    dayHasHoursAvailable: {
      default: false
    }
  },
});

export default ServiceAppointProps;
